import styled from 'styled-components';

export const FriendsPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0px 48px;
`;

export const HeaderTopBar = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const SearchBarComponent = styled.div`
    align-items: center;
    display: flex;
    gap: 12px;
    width: 100%;
    max-width: 320px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;


export const FriendsContent = styled.div`
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const FriendList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const FriendCard = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    
    h3 {
        margin: 0;
    }
`;

export const FriendInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;

    & > div {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }

    h3, strong {
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 600;
        margin: 0;
    }

    & > div > div {
        color: rgba(255, 255, 255, 0.7);
        font-size: 12px;
    }
`;

export const ActionButtons = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const EmptyState = styled.div`
    padding: 48px;
    text-align: center;
    opacity: 0.6;

    p {
        color: #FFFFFF;
        font-size: 16px;
    }
`;

